(function() {
  'use strict';

  angular.module('codecutoff').factory('Collection', [
    '$http', '$log',

    function($http, $log) {

      return {
        getAll:  getAll
      };

      /*----------------------------------------------------------------------------------------------
       * MANAGEMENT METHODS
       *--------------------------------------------------------------------------------------------*/
      function  getAll() {
        return $http({
          method: 'GET',
          url: _url()
        }).then(_success);
      }

      /*----------------------------------------------------------------------------------------------
      /*----------------------------------------------------------------------------------------------
       * HELPER METHODS
       *--------------------------------------------------------------------------------------------*/

      // This is a general success that strips response data off of the promise.
      function _success(response) {
        return response.data.custom_collections;
      }

      function _url(category) {
        return '/admin/custom_collections.json';
      }

  }]);
})();
